import { makeUrl } from "src/navigation/makeUrl";

export const urlSecureShort = (restPath?: string): string =>
  ["/secure", ...(restPath?.split("/") ?? [])].filter((s) => !!s).join("/");

export const urlSecure = (restPath?: string): string =>
  makeUrl(urlSecureShort(restPath));
